import React from 'react'
import { useState } from 'react'
import { EditorCode } from '../../../../components/EditorCode/EditorCode';
import { useDebounce } from '../../../../hooks/useDebounce'
import "./Code.scss"

const Code = (({
    id,
    data,
    changeContent,
    setIsModal,
    ind,
    setCurrentIndex,
    setContentArr,
    readonly = false,
}) => {
    const [content, setContent] = useState(data[0]?.value || '')

    const debounceChange = useDebounce(changeContent, 1000)

    const handleAddContent = (content) => {
        debounceChange(id,
            [
                {
                    value: content,
                    properties: {}
                }
            ]
        )
        setContentArr((prev) => {
            return prev.map((el) => {
                if (el?.block_id == id) {
                    return {
                        ...el,
                        value: content
                    }
                } else {
                    return el
                }
            })
        })
    }

    return (
        < div className='editor-code-type'
            onContextMenu={(e) => {
                if (!readonly) {
                    e.preventDefault()
                    setCurrentIndex(ind)
                    setIsModal(true)
                }
            }}
        >
            <EditorCode
                id={id}
                value={content}
                onChange={(e) => {
                    if (!readonly) {
                        handleAddContent(e)
                    }
                }}
            />
        </div >
    )
})

export { Code }